import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import BottomTabBar from '../components/BottomTabBar';
import Drawer from '../components/Drawer';
import '../styles/mobile.css';

export default function MobileLayout({ children }) {
  const { user }           = useAuth();
  const navigate           = useNavigate();
  const [drawerOpen, setDrawerOpen] = useState(false);

  return (
    <div className="mb-root mb-layout">
      {/* 드로어 메뉴 (오버레이 포함) */}
      <Drawer open={drawerOpen} onClose={() => setDrawerOpen(false)} />

      <header className="mb-header">
        {/* 좌측: 햄버거 + 타이틀 */}
        <div className="mb-header-left">
          <button
            className="mb-hamburger"
            onClick={() => setDrawerOpen(true)}
            aria-label="메뉴 열기"
          >
            ☰
          </button>
          <button
            className="mb-header-title-btn"
            onClick={() => navigate('/mobile/dashboard')}
          >
            K.G.B 투자
          </button>
        </div>

        {/* 우측: 사용자명 */}
        <div className="mb-header-right">
          <span className="mb-header-user">{user?.user_name || user?.user_id || ''}</span>
        </div>
      </header>

      <main className="mb-content">{children}</main>

      <BottomTabBar />
    </div>
  );
}
